import { EPageType } from '../../types/pageType';
import { IApplicationState } from '../../types/redux';

export function pageTypeReducer(state: IApplicationState['pageType'] = EPageType.MAIN): IApplicationState['pageType'] {
  return state;
}
